import { render, staticRenderFns } from "./EditDisable.vue?vue&type=template&id=89232006&scoped=true&"
import script from "./EditDisable.vue?vue&type=script&lang=js&"
export * from "./EditDisable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89232006",
  null
  
)

export default component.exports